import { AllMarketingConsentsValues } from 'modules/customer'

export const getConsentValue = (
  values: Partial<AllMarketingConsentsValues> | undefined,
  key: string
) => {
  return (values && key in values && Boolean(values[key])) || false
}
